// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as CardValidations$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CardValidations.bs.js";
import * as CardSchemeComponent$OrcaPaymentPage from "../CardSchemeComponent.bs.js";

function useCardForm(logger, paymentType) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var cardScheme = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.cardBrand);
  var showPaymentMethodsScreen = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  var selectedOption = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.selectedOptionAtom);
  var blockedBinsList = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.blockedBins);
  var paymentToken = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentTokenAtom);
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var match$1 = React.useState(function () {
        return "";
      });
  var setCardNumber = match$1[1];
  var cardNumber = match$1[0];
  var match$2 = React.useState(function () {
        return "";
      });
  var setCardExpiry = match$2[1];
  var cardExpiry = match$2[0];
  var match$3 = React.useState(function () {
        return "";
      });
  var setCvcNumber = match$3[1];
  var cvcNumber = match$3[0];
  var match$4 = React.useState(function () {
        return "";
      });
  var setZipCode = match$4[1];
  var zipCode = match$4[0];
  var match$5 = React.useState(function () {
        return "";
      });
  var setCardError = match$5[1];
  var match$6 = React.useState(function () {
        return "";
      });
  var setCvcError = match$6[1];
  var match$7 = React.useState(function () {
        return "";
      });
  var setExpiryError = match$7[1];
  var match$8 = React.useState(function () {
        return false;
      });
  var setDisplayPincode = match$8[1];
  var match$9 = React.useState(function () {
        return false;
      });
  var setBlurState = match$9[1];
  var cardRef = React.useRef(null);
  var expiryRef = React.useRef(null);
  var cvcRef = React.useRef(null);
  var zipRef = React.useRef(null);
  var isCoBadgedCardDetectedOnce = React.useRef(false);
  var prevCardBrandRef = React.useRef("");
  var match$10 = React.useState(function () {
        
      });
  var setIsCardValid = match$10[1];
  var isCardValid = match$10[0];
  var match$11 = React.useState(function () {
        
      });
  var setIsExpiryValid = match$11[1];
  var isExpiryValid = match$11[0];
  var match$12 = React.useState(function () {
        
      });
  var setIsCVCValid = match$12[1];
  var isCVCValid = match$12[0];
  var match$13 = React.useState(function () {
        
      });
  var setIsZipValid = match$13[1];
  var match$14 = React.useState(function () {
        
      });
  var setIsCardSupported = match$14[1];
  var isCardSupported = match$14[0];
  var cardBrand = CardUtils$OrcaPaymentPage.getCardBrand(cardNumber);
  var isNotBancontact = selectedOption !== "bancontact_card" && cardBrand === "";
  var match$15 = React.useState(function () {
        if (!showPaymentMethodsScreen && isNotBancontact) {
          return cardScheme;
        } else {
          return cardBrand;
        }
      });
  var setCardBrand = match$15[1];
  var cardBrand$1 = CardUtils$OrcaPaymentPage.getCardBrandFromStates(match$15[0], cardScheme, showPaymentMethodsScreen);
  var supportedCardBrands = React.useMemo((function () {
          return PaymentUtils$OrcaPaymentPage.getSupportedCardBrands(paymentMethodListValue);
        }), [paymentMethodListValue]);
  var maxCardLength = React.useMemo((function () {
          return CardUtils$OrcaPaymentPage.getMaxLength(cardBrand$1);
        }), [
        cardNumber,
        cardScheme,
        cardBrand$1,
        showPaymentMethodsScreen
      ]);
  React.useEffect((function () {
          setIsCardSupported(function (param) {
                return PaymentUtils$OrcaPaymentPage.checkIsCardSupported(cardNumber, cardBrand$1, supportedCardBrands);
              });
        }), [
        supportedCardBrands,
        cardNumber,
        cardBrand$1
      ]);
  var cardType = React.useMemo((function () {
          return CardUtils$OrcaPaymentPage.getCardType(cardBrand$1);
        }), [cardBrand$1]);
  React.useEffect((function () {
          var obj = CardValidations$OrcaPaymentPage.getobjFromCardPattern(cardBrand$1);
          var cvcLength = obj.maxCVCLength;
          if (CardUtils$OrcaPaymentPage.cvcNumberInRange(cvcNumber, cardBrand$1).includes(true) && cvcNumber.length === cvcLength) {
            CardUtils$OrcaPaymentPage.blurRef(cvcRef);
          }
          
        }), [
        cvcNumber,
        cardNumber
      ]);
  React.useEffect((function () {
          setCvcNumber(function (param) {
                return "";
              });
          setCardExpiry(function (param) {
                return "";
              });
          setIsExpiryValid(function (param) {
                
              });
          setIsCVCValid(function (param) {
                
              });
        }), [showPaymentMethodsScreen]);
  React.useEffect((function () {
          if (!isCoBadgedCardDetectedOnce.current) {
            setCvcNumber(function (param) {
                  return "";
                });
            setCardExpiry(function (param) {
                  return "";
                });
            setIsExpiryValid(function (param) {
                  
                });
            setIsCVCValid(function (param) {
                  
                });
          }
          prevCardBrandRef.current = cardBrand$1;
        }), [cardBrand$1]);
  React.useEffect((function () {
          setCvcNumber(function (param) {
                return "";
              });
          setIsCVCValid(function (param) {
                
              });
          setCvcError(function (param) {
                return "";
              });
          setCardError(function (param) {
                return "";
              });
          setExpiryError(function (param) {
                return "";
              });
        }), [
        paymentToken.paymentToken,
        showPaymentMethodsScreen
      ]);
  var changeCardNumber = function (ev) {
    var val = ev.target.value;
    LoggerUtils$OrcaPaymentPage.logInputChangeInfo("cardNumber", logger);
    var card = CardUtils$OrcaPaymentPage.formatCardNumber(val, cardType);
    var clearValue = CardValidations$OrcaPaymentPage.clearSpaces(card);
    var isCardBlocked = CardUtils$OrcaPaymentPage.checkIfCardBinIsBlocked(clearValue, blockedBinsList);
    if (isCardBlocked) {
      setCardError(function (param) {
            return localeString.blockedCardText;
          });
      setIsCardValid(function (param) {
            return false;
          });
    } else {
      CardUtils$OrcaPaymentPage.setCardValid(clearValue, cardBrand$1, setIsCardValid);
    }
    if (CardUtils$OrcaPaymentPage.focusCardValid(clearValue, cardBrand$1) && Core__Option.getOr(PaymentUtils$OrcaPaymentPage.checkIsCardSupported(clearValue, cardBrand$1, supportedCardBrands), false) && !isCardBlocked) {
      CardUtils$OrcaPaymentPage.handleInputFocus(cardRef, expiryRef);
    }
    if (card.length > 6 && CardUtils$OrcaPaymentPage.pincodeVisibility(cardBrand$1)) {
      setDisplayPincode(function (param) {
            return true;
          });
    } else if (card.length < 8) {
      setDisplayPincode(function (param) {
            return false;
          });
    }
    setCardNumber(function (param) {
          return card;
        });
    if (card.length === 0 && prevCardBrandRef.current !== "") {
      setCvcNumber(function (param) {
            return "";
          });
      setCardExpiry(function (param) {
            return "";
          });
      setIsExpiryValid(function (param) {
            
          });
      setIsCVCValid(function (param) {
            
          });
      return setIsCardValid(function (param) {
                  return false;
                });
    }
    
  };
  var changeCardExpiry = function (ev) {
    var val = ev.target.value;
    LoggerUtils$OrcaPaymentPage.logInputChangeInfo("cardExpiry", logger);
    var formattedExpiry = CardValidations$OrcaPaymentPage.formatCardExpiryNumber(val);
    if (CardUtils$OrcaPaymentPage.isExipryValid(formattedExpiry)) {
      CardUtils$OrcaPaymentPage.handleInputFocus(expiryRef, cvcRef);
      CardUtils$OrcaPaymentPage.emitExpiryDate(formattedExpiry);
    }
    CardUtils$OrcaPaymentPage.setExpiryValid(formattedExpiry, setIsExpiryValid);
    setCardExpiry(function (param) {
          return formattedExpiry;
        });
  };
  var changeCVCNumber = function (ev) {
    var val = ev.target.value;
    LoggerUtils$OrcaPaymentPage.logInputChangeInfo("cardCVC", logger);
    var cvc = CardValidations$OrcaPaymentPage.formatCVCNumber(val, cardBrand$1);
    setCvcNumber(function (param) {
          return cvc;
        });
    if (cvc.length > 0 && CardUtils$OrcaPaymentPage.cvcNumberInRange(cvc, cardBrand$1).includes(true)) {
      Core__Option.forEach(Caml_option.nullable_to_opt(zipRef.current), (function (input) {
              input.focus();
            }));
    }
    if (cvc.length > 0 && CardUtils$OrcaPaymentPage.cvcNumberInRange(cvc, cardBrand$1).includes(true)) {
      return setIsCVCValid(function (param) {
                  return true;
                });
    } else {
      return setIsCVCValid(function (param) {
                  
                });
    }
  };
  var changeZipCode = function (ev) {
    var val = ev.target.value;
    LoggerUtils$OrcaPaymentPage.logInputChangeInfo("zipCode", logger);
    setZipCode(function (param) {
          return val;
        });
  };
  var onZipCodeKeyDown = function (ev) {
    CardUtils$OrcaPaymentPage.commonKeyDownEvent(ev, zipRef, cvcRef, zipCode, cvcNumber, setCvcNumber);
  };
  var onCvcKeyDown = function (ev) {
    CardUtils$OrcaPaymentPage.commonKeyDownEvent(ev, cvcRef, expiryRef, cvcNumber, cardExpiry, setCardExpiry);
  };
  var onExpiryKeyDown = function (ev) {
    CardUtils$OrcaPaymentPage.commonKeyDownEvent(ev, expiryRef, cardRef, cardExpiry, cardNumber, setCardNumber);
  };
  React.useEffect((function () {
          var handleFun = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
            if (Core__Option.isSome(dict["doBlur"])) {
              logger.setLogInfo("doBlur Triggered", "BLUR", undefined, undefined, undefined, undefined, undefined);
              return setBlurState(function (param) {
                          return true;
                        });
            } else if (Core__Option.isSome(dict["doFocus"])) {
              logger.setLogInfo("doFocus Triggered", "FOCUS", undefined, undefined, undefined, undefined, undefined);
              Core__Option.forEach(Caml_option.nullable_to_opt(cardRef.current), (function (input) {
                      input.focus();
                    }));
              return ;
            } else if (Core__Option.isSome(dict["doClearValues"])) {
              logger.setLogInfo("doClearValues Triggered", "CLEAR", undefined, undefined, undefined, undefined, undefined);
              setCardNumber(function (param) {
                    return "";
                  });
              setCardExpiry(function (param) {
                    return "";
                  });
              setCvcNumber(function (param) {
                    return "";
                  });
              setIsCardValid(function (param) {
                    
                  });
              setCardError(function (param) {
                    return "";
                  });
              setCvcError(function (param) {
                    return "";
                  });
              setExpiryError(function (param) {
                    return "";
                  });
              setIsExpiryValid(function (param) {
                    
                  });
              return setIsCVCValid(function (param) {
                          
                        });
            } else {
              return ;
            }
          };
          return Utils$OrcaPaymentPage.handleMessage(handleFun, "Error in parsing sent Data");
        }), []);
  var handleCardBlur = function (ev) {
    var cardNumber = ev.target.value;
    if (CardUtils$OrcaPaymentPage.cardNumberInRange(cardNumber, cardBrand$1).includes(true) && CardUtils$OrcaPaymentPage.calculateLuhn(cardNumber)) {
      return setIsCardValid(function (param) {
                  return PaymentUtils$OrcaPaymentPage.checkIsCardSupported(cardNumber, cardBrand$1, supportedCardBrands);
                });
    } else if (cardNumber.length === 0) {
      return setIsCardValid(function (param) {
                  return false;
                });
    } else {
      return setIsCardValid(function (param) {
                  return false;
                });
    }
  };
  var handleExpiryBlur = function (ev) {
    var cardExpiry = ev.target.value;
    if (cardExpiry.length > 0 && CardUtils$OrcaPaymentPage.getExpiryValidity(cardExpiry)) {
      return setIsExpiryValid(function (param) {
                  return true;
                });
    } else if (cardExpiry.length === 0) {
      return setIsExpiryValid(function (param) {
                  
                });
    } else {
      return setIsExpiryValid(function (param) {
                  return false;
                });
    }
  };
  var handleCVCBlur = function (ev) {
    var cvcNumber = ev.target.value;
    if (cvcNumber.length > 0 && CardUtils$OrcaPaymentPage.cvcNumberInRange(cvcNumber, cardBrand$1).includes(true)) {
      return setIsCVCValid(function (param) {
                  return true;
                });
    } else if (cvcNumber.length === 0) {
      return setIsCVCValid(function (param) {
                  
                });
    } else {
      return setIsCVCValid(function (param) {
                  return false;
                });
    }
  };
  var handleZipBlur = function (ev) {
    var zipCode = ev.target.value;
    if (zipCode === "") {
      return setIsZipValid(function (param) {
                  return false;
                });
    } else {
      return setIsZipValid(function (param) {
                  return true;
                });
    }
  };
  React.useEffect((function () {
          var isCardBlocked = CardUtils$OrcaPaymentPage.checkIfCardBinIsBlocked(CardValidations$OrcaPaymentPage.clearSpaces(cardNumber), blockedBinsList);
          var match = Core__Option.getOr(isCardSupported, true);
          var match$1 = Core__Option.getOr(isCardValid, true);
          var match$2 = cardNumber.length === 0;
          var cardError = isCardBlocked ? localeString.blockedCardText : (
              match$2 ? "" : (
                  match ? (
                      match$1 ? "" : localeString.inValidCardErrorText
                    ) : CardUtils$OrcaPaymentPage.getCardBrandInvalidError(cardBrand$1, localeString)
                )
            );
          var cardError$1 = Core__Option.isSome(isCardValid) ? cardError : "";
          setCardError(function (param) {
                return cardError$1;
              });
        }), [
        isCardValid,
        isCardSupported,
        cardNumber,
        blockedBinsList
      ]);
  React.useEffect((function () {
          setCvcError(function (param) {
                if (Core__Option.getOr(isCVCValid, true)) {
                  return "";
                } else {
                  return localeString.inCompleteCVCErrorText;
                }
              });
        }), [isCVCValid]);
  React.useEffect((function () {
          setExpiryError(function (param) {
                var match = CardUtils$OrcaPaymentPage.isExpiryComplete(cardExpiry);
                if (isExpiryValid !== undefined) {
                  if (isExpiryValid) {
                    if (match) {
                      return "";
                    } else {
                      return localeString.inCompleteExpiryErrorText;
                    }
                  } else if (match) {
                    return localeString.pastExpiryErrorText;
                  } else {
                    return localeString.inCompleteExpiryErrorText;
                  }
                } else {
                  return "";
                }
              });
        }), [
        isExpiryValid,
        CardUtils$OrcaPaymentPage.isExpiryComplete(cardExpiry)
      ]);
  React.useEffect((function () {
          var validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(cardNumber, Core__Option.getOr(supportedCardBrands, []));
          var newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(cardNumber);
          setCardBrand(function (param) {
                return newCardBrand;
              });
        }), [cardNumber]);
  var icon = React.useMemo((function () {
          return React.createElement(CardSchemeComponent$OrcaPaymentPage.make, {
                      cardNumber: cardNumber,
                      paymentType: paymentType,
                      cardBrand: cardBrand$1,
                      setCardBrand: setCardBrand,
                      isCoBadgedCardDetectedOnce: isCoBadgedCardDetectedOnce
                    });
        }), [
        cardType,
        paymentType,
        cardBrand$1,
        cardNumber
      ]);
  var cardProps_cardError = match$5[0];
  var cardProps = {
    isCardValid: isCardValid,
    setIsCardValid: setIsCardValid,
    isCardSupported: isCardSupported,
    cardNumber: cardNumber,
    changeCardNumber: changeCardNumber,
    handleCardBlur: handleCardBlur,
    cardRef: cardRef,
    icon: icon,
    cardError: cardProps_cardError,
    setCardError: setCardError,
    maxCardLength: maxCardLength,
    cardBrand: cardBrand$1
  };
  var expiryProps_expiryError = match$7[0];
  var expiryProps = {
    isExpiryValid: isExpiryValid,
    setIsExpiryValid: setIsExpiryValid,
    cardExpiry: cardExpiry,
    changeCardExpiry: changeCardExpiry,
    handleExpiryBlur: handleExpiryBlur,
    expiryRef: expiryRef,
    onExpiryKeyDown: onExpiryKeyDown,
    expiryError: expiryProps_expiryError,
    setExpiryError: setExpiryError
  };
  var cvcProps_cvcError = match$6[0];
  var cvcProps = {
    isCVCValid: isCVCValid,
    setIsCVCValid: setIsCVCValid,
    cvcNumber: cvcNumber,
    setCvcNumber: setCvcNumber,
    changeCVCNumber: changeCVCNumber,
    handleCVCBlur: handleCVCBlur,
    cvcRef: cvcRef,
    onCvcKeyDown: onCvcKeyDown,
    cvcError: cvcProps_cvcError,
    setCvcError: setCvcError
  };
  var zipProps_isZipValid = match$13[0];
  var zipProps_displayPincode = match$8[0];
  var zipProps = {
    isZipValid: zipProps_isZipValid,
    setIsZipValid: setIsZipValid,
    zipCode: zipCode,
    changeZipCode: changeZipCode,
    handleZipBlur: handleZipBlur,
    zipRef: zipRef,
    onZipCodeKeyDown: onZipCodeKeyDown,
    displayPincode: zipProps_displayPincode
  };
  return {
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps,
          zipProps: zipProps,
          blurState: match$9[0]
        };
}

export {
  useCardForm ,
}
/* react Not a pure module */
